import { useQueryClient } from '@tanstack/react-query'
import {
  usePostAdminsMedications,
  getGetAdminsMedicationsQueryKey,
  usePostAdminsMedicationsImages,
} from '@/api/generated/medication/medication'
import type { MedicationStaffApiOutContract } from '@/api/generated/pwrdbyQuickMDAdminsApi.schemas'
import type { CreateMedicationInput } from '../types'
import { mapMedicationIn } from './adapters'

export function useCreateMedication() {
  const queryClient = useQueryClient()
  const { mutateAsync: orvalMutateAsync, isPending: isCreating } = usePostAdminsMedications()
  const { mutateAsync: uploadImage, isPending: isUploading } = usePostAdminsMedicationsImages()

  async function mutateAsync(data: CreateMedicationInput): Promise<string> {
    let imageUrl = ''
    if (data.medicationImage) {
      const result = await uploadImage({ data: { image: data.medicationImage } })
      imageUrl = result.ImageUrl ?? ''
    }
    const apiData = mapMedicationIn(data, imageUrl)
    const created = await orvalMutateAsync({ data: apiData })

    const listKey = getGetAdminsMedicationsQueryKey()
    queryClient.setQueryData<MedicationStaffApiOutContract[]>(listKey, (old) => [...(old ?? []), created])
    queryClient.invalidateQueries({ queryKey: listKey })

    return created.Id ?? ''
  }

  return { mutateAsync, isPending: isCreating || isUploading }
}
